import { SwadeshFullWidthMediaProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<SwadeshFullWidthMediaProps>
  ): React.FC<SwadeshFullWidthMediaProps> =>
  (props: SwadeshFullWidthMediaProps) => {
    return <Component {...props} />;
  };
